import React from 'react';

import FieldText from '../commons/FieldText';
import FieldBirthday from '../commons/FieldBirthday';

const GeneralData = () => {
  return (
    <div>
      <h3>Datos Generales</h3>
      <hr className="solid" />
      <div className="field-row">
        <FieldText
          label="Nombre"
          name="name"
          required />
        <FieldText
          label="Apellido Paterno"
          name="firstLastname"
          required />
      </div>
      <div className="field-row">
        <FieldText
          label="Apellido Materno"
          name="secondLastname"
          required />
        <FieldText
          maxLength={13}
          label="RFC"
          name="rfc"
          required />
      </div>
      <div className="field-row">
        <div className="field -double-input">
          <FieldBirthday
            label="Fecha de nacimiento"
            name="birthdate"
            className="field -input -half"
            required />
        </div>
      </div>
    </div>
  );
};

export default GeneralData;
